import { UserDisplayNameEntity } from 'Models/Entities';
import { create } from 'zustand';
import { fetchUserDisplayTypes } from 'Services/Api/_HumanWritten/UserService';

interface UserDisplayNameStore {
	userDisplayNames: UserDisplayNameEntity[];
	setUserDisplayNames: (userDisplayNames: UserDisplayNameEntity[]) => void;
}

// In-memory only. The previous sessionStorage persistence overflowed the quota
// once each display name's deep DefaultPricing graph was included on every
// refresh, and we always refetch on app load and after default-pricing writes.
export const useUserDisplayNamesStore = create<UserDisplayNameStore>(set => ({
	userDisplayNames: [],
	setUserDisplayNames: (userDisplayNames: UserDisplayNameEntity[]) => set({ userDisplayNames }),
}));

export const retrieveUserDisplayNamesAsync = async () => {
	const userDisplayNamesStore = useUserDisplayNamesStore.getState();

	const userDisplayNameEntities = await fetchUserDisplayTypes();
	if (!userDisplayNameEntities) return;
	userDisplayNamesStore.setUserDisplayNames(userDisplayNameEntities);
};
